import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import SelectChecbox from './components/SelectCheckbox';
import Overview from './components/Overview';
import TotalPrice from './components/TotalPrice';
import SelectRadio from './components/SelectRadio';
import SelectedItem from './components/SelectedItem';

import {
    createStore,
    compose,
    applyMiddleware
} from 'redux'

import {
    Provider
} from 'react-redux';

import {
    options
} from './reducers'

import {
    each
} from 'lodash-es'

import {
    getElementDataAttributes
} from './utils/parsers'

import {
    registerComponent
} from './actions/select'

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = createStore(
    options,
    composeEnhancer(applyMiddleware(thunk))
);

const getComponent = (state, {property, variant}) => {
    switch (property) {
        case 'totalPrice':
            return TotalPrice;
        case 'overview':
            return Overview;
        default:
            break;
    }

    if (!state[property]) {
        throw new Error(`Invalid attribute data-property (${property})`)
    }

    switch (variant) {
        case 'current-choice':
            return SelectedItem;
        case 'radio':
            return SelectRadio;
        default:
            return SelectChecbox;
    }
};

const configuratorElements = document.getElementsByClassName('configurator-field');

each(configuratorElements, element => {
    const settings = getElementDataAttributes(element);
    try {
        const Component = getComponent(store.getState(), settings);
        if (Component) {
            store.dispatch(registerComponent(settings));
            ReactDOM.render((
                <Provider store={store}>
                    <Component {...settings} id={element.id}/>
                </Provider>
            ), element);
            element.removeAttribute('id');
        }
    } catch (e) {
        console.error(e.message);
    }
});



// WEBPACK FOOTER //
// ./src/index.js